<div class="reservation-container">

  <div class="container-details">
      <app-stats-horizontal [stats]="warehouseStats" variant="highlight"></app-stats-horizontal>
  </div>
  
  <app-tos-table
  [stats]="tableStats"
  [showTableStats]="false"
  [tableMeta]="tableMeta"
  [defaultFilters]="defaultFilters"
  [tableMenuOptions]="menuOptions"
  [showMenuOptions]="false"
  [(dataListRequest)]="tableListRequest"
  [dataListResponse]="tableListData"
  [(selectedItems)]="selectedItems"
  (tosTableAction)="fetchAllRecords()"
  ></app-tos-table>
</div>